/**
 * Assign members of second array to first
 */
export const assignMap = (target: Map<any, any>, source: Map<any, any>): void =>
	source.forEach((key, value) => target.set(value, key));
